export default __webpack_public_path__ + "static/tires-one-839acc9171a498042f6ea5de1bf18111.svg";